import { useEffect, useRef, useState } from 'react';
import { ApiClientService, useApiClient } from 'libs.react_internal';
import { fetchConsentAssetDataUrl } from './consent_template_library_fetch';
/** Fetches the CONSENT_ASSET PDF when `enabled`. */
export const useConsentTemplateAsset = (assetId, enabled) => {
    const [state, setState] = useState({ status: 'idle' });
    const { get } = useApiClient(ApiClientService.LIBRARY);
    const getRef = useRef(get);
    getRef.current = get;
    useEffect(() => {
        if (!enabled) {
            setState({ status: 'idle' });
            return;
        }
        if (!assetId) {
            setState({ status: 'error', message: 'No CONSENT_ASSET linked to this template.' });
            return;
        }
        let cancelled = false;
        setState({ status: 'loading' });
        (async () => {
            try {
                const pdfDataUrl = await fetchConsentAssetDataUrl(getRef.current, assetId);
                if (!cancelled) {
                    setState({ status: 'ready', pdfDataUrl });
                }
            }
            catch (error) {
                if (!cancelled) {
                    setState({
                        status: 'error',
                        message: error instanceof Error ? error.message : 'Failed to load PDF.',
                    });
                }
            }
        })();
        return () => {
            cancelled = true;
        };
    }, [assetId, enabled]);
    return state;
};
